import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { formatDate } from '../../../lib/Dates'
import { Spend } from '../../../lib/Types'
import LineChart from '../../Charts/LineChart'
import Headline from '../../Elements/Headline'

type Props = {
  spend: Spend
}

const SpendDevelopment: FC<Props> = ({ spend }) => {
  const { t } = useTranslation(['budget'])
  const data = spend.amounts.reduce(
    (obj, spend) => {
      const createdDate = spend.created_date
        ? new Date(spend.created_date)
        : new Date()
      obj[formatDate(createdDate, 'yyyy-mm-dd')] = spend.amount
      return obj
    },
    {} as Record<string, number>,
  )

  return (
    <>
      <Headline>{t('budget:shared.development')}</Headline>
      <p className='mt-2 mb-5'>{t('budget:spendDevelopment.description')}</p>
      {spend.amounts.length === 0 && (
        <p className='italic'>{t('budget:shared.notEnoughData')}</p>
      )}
      <LineChart data={data} />
    </>
  )
}

export default SpendDevelopment
